import * as React from 'react'

export const languageSwitch = (open: boolean) => {
  return (
    <div className={`countries-nav cv cv--${open == true ? 'show' : 'hide'}`}>
      <div className="cv__outer">
        <button className="cv__button">
          {/* TO DO: OnCLick event needs to close country nav pop up*/}
          <span className="sr-text">Closing overlay button</span>
          <img className="languages__logo" src="/images/icons/icon--close--orange.svg" alt="" height="30" width="32"/>
        </button>
        <svg className="cv__logo" aria-hidden="true" height="80" width="169">
          <use xlinkHref="#logo--tagline" />
        </svg>
        <div className="cv__divider"></div>
        <div className="cv__inner container container--m grid--gutter">
          <header className="cv__header">
            <h1 className="cv__title">
              You are currently visiting the international corporate website of Refresco. If you would like to visit one
              of our local websites, please select your region from the list below.</h1>
              <a className="button button--primary" href='/'>Continue to Refresco Group</a>
          </header>
          <nav className="nav nav--countries">
            <ul className="nav__list">
              <li className="nav__item">
                <a className="item__link item__link--benelux" href="">
                  <span className="item__title">Benelux</span>
                  <span className="item__subtitle text--m">Fermentum</span>
                  <div className="item__flags">
                    <svg className="item__flag" aria-hidden="true" height="18" width="24">
                      <use xlinkHref="#flag--nl" />
                    </svg>
                    <svg className="item__flag" aria-hidden="true" height="18" width="24">
                      <use xlinkHref="#flag--be" />
                    </svg>
                    <svg className="item__flag" aria-hidden="true" height="18" width="24">
                      <use xlinkHref="#flag--lu" />
                    </svg>
                  </div>
                </a>
              </li>
              <li className="nav__item item">
                <a className="item__link item__link--na" href="">
                  <span className="item__title">Benelux</span>
                  <span className="item__subtitle text--m">Fermentum</span>
                  <div className="item__flags">
                    <svg className="item__flag" aria-hidden="true" height="18" width="24">
                      <use xlinkHref="#flag--us" />
                    </svg>
                    <svg className="item__flag" aria-hidden="true" height="18" width="24">
                      <use xlinkHref="#flag--ca" />
                    </svg>
                    <svg className="item__flag" aria-hidden="true" height="18" width="24">
                      <use xlinkHref="#flag--mx" />
                    </svg>
                  </div>
                </a>
              </li>
              <li className="nav__item">
                <a className="item__link item__link--finland" href="">
                  <span className="item__title">Benelux</span>
                  <span className="item__subtitle text--m">Fermentum</span>
                  <div className="item__flags">
                    <svg className="item__flag" aria-hidden="true" height="18" width="24">
                      <use xlinkHref="#flag--fi" />
                    </svg>
                  </div>
                </a>
              </li>
              <li className="nav__item">
                <a className="item__link item__link--italy" href="">
                  <span className="item__title">Benelux</span>
                  <span className="item__subtitle text--m">Fermentum</span>
                  <div className="item__flags">
                    <svg className="item__flag" aria-hidden="true" height="18" width="24">
                      <use xlinkHref="#flag--it" />
                    </svg>
                  </div>
                </a>
              </li>
              <li className="nav__item">
                <a className="item__link item__link--france" href="">
                  <span className="item__title">Benelux</span>
                  <span className="item__subtitle text--m">Fermentum</span>
                  <div className="item__flags">
                    <svg className="item__flag" aria-hidden="true" height="18" width="24">
                      <use xlinkHref="#flag--fr" />
                    </svg>
                  </div>
                </a>
              </li>
              <li className="nav__item">
                <a className="item__link item__link--poland" href="">
                  <span className="item__title">Benelux</span>
                  <span className="item__subtitle text--m">Fermentum</span>
                  <div className="item__flags">
                    <svg className="item__flag" aria-hidden="true" height="18" width="24">
                      <use xlinkHref="#flag--pl" />
                    </svg>
                  </div>
                </a>
              </li>
              <li className="nav__item">
                <a className="item__link item__link--germany" href="">
                  <span className="item__title">Benelux</span>
                  <span className="item__subtitle text--m">Fermentum</span>
                  <div className="item__flags">
                    <svg className="item__flag" aria-hidden="true" height="18" width="24">
                      <use xlinkHref="#flag--de" />
                    </svg>
                  </div>
                </a>
              </li>
              <li className="nav__item">
                <a className="item__link item__link--uk" href="">
                  <span className="item__title">Benelux</span>
                  <span className="item__subtitle text--m">Fermentum</span>
                  <div className="item__flags">
                    <svg className="item__flag" aria-hidden="true" height="18" width="24">
                      <use xlinkHref="#flag--uk" />
                    </svg>
                  </div>
                </a>
              </li>
              <li className="nav__item">
                <a className="item__link item__link--iberia" href="">
                  <span className="item__title">Benelux</span>
                  <span className="item__subtitle text--m">Fermentum</span>
                  <div className="item__flags">
                    <svg className="item__flag" aria-hidden="true" height="18" width="24">
                      <use xlinkHref="#flag--es" />
                    </svg>
                  </div>
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  )
}


